export const TITLE =
  'Submit nursing home information in connection with claim for Aid and Attendance';
export const SUBTITLE =
  'Request for Nursing Home Information in Connection with Claim for Aid and Attendance (VA Form 21-0779)';

// API Endpoints
export const API_ENDPOINTS = {
  csrfCheck: '/csrf_token',
  downloadPdf: '/form210779/download_pdf',
};
